<template>
  <section
    class="sec sec--centered reveal"
    id="how"
    data-ga-section="how_it_works"
  >
    <div class="sec-head-row sec-head-row--centered">
      <span class="sec-eyebrow">{{ trans.get('landing.how.eyebrow') }}</span>
      <h2 class="sec-title sec-title--centered">
        {{ trans.get('landing.how.title_line1') }}<br />
        {{ trans.get('landing.how.title_line2_prefix') }}
        <span class="grad">{{ trans.get('landing.how.title_line2_grad') }}</span
        ><span class="title-dot">{{ trans.get('landing.how.title_line2_dot') }}</span>
      </h2>
      <p class="sec-lede sec-lede--centered">{{ trans.get('landing.how.lede') }}</p>
    </div>

    <div class="how how--compact">
      <div class="step">
        <div class="num">{{ trans.get('landing.how.step1_num') }}</div>
        <h3>{{ trans.get('landing.how.step1_title') }}</h3>
        <p>{{ trans.get('landing.how.step1_text') }}</p>
        <div class="vis">
          <div class="vis-profile">
            <div class="av av--lena"></div>
            <div class="nm">{{ trans.get('landing.how.step1_profile_name') }}</div>
            <div class="age">{{ trans.get('landing.how.step1_profile_age') }}</div>
            <div class="tags">
              <span class="tag">{{ trans.get('landing.how.step1_tag_1') }}</span>
              <span class="tag">{{ trans.get('landing.how.step1_tag_2') }}</span>
              <span class="tag">{{ trans.get('landing.how.step1_tag_3') }}</span>
            </div>
          </div>
          <span class="chip chip--verified">
            <span class="chip-check"><icon-check :size="11" /></span>
            <span class="chip-label">{{ trans.get('landing.how.step1_verified') }}</span>
          </span>
        </div>
      </div>

      <div class="step">
        <div class="num">{{ trans.get('landing.how.step2_num') }}</div>
        <h3>{{ trans.get('landing.how.step2_title') }}</h3>
        <p>{{ trans.get('landing.how.step2_text') }}</p>
        <div class="vis">
          <div class="vis-quiz">
            <div class="q">{{ trans.get('landing.how.step2_q') }}</div>
            <div class="opt">{{ trans.get('landing.how.step2_opt_1') }}</div>
            <div class="opt right">{{ trans.get('landing.how.step2_opt_2') }}</div>
            <div class="opt">{{ trans.get('landing.how.step2_opt_3') }}</div>
          </div>
        </div>
      </div>

      <div class="step">
        <div class="num">{{ trans.get('landing.how.step3_num') }}</div>
        <h3>{{ trans.get('landing.how.step3_title') }}</h3>
        <p>{{ trans.get('landing.how.step3_text') }}</p>
        <div class="vis">
          <div class="vis-chat">
            <div class="b them">{{ trans.get('landing.how.step3_msg_1') }}</div>
            <div class="b me">{{ trans.get('landing.how.step3_msg_2') }}</div>
            <div class="b them">{{ trans.get('landing.how.step3_msg_3') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="how-cta">
      <button
        class="btn-primary"
        type="button"
        data-cta-location="how_it_works"
        @click="openSignup"
      >
        {{ trans.get('landing.how.cta') }}
        <span class="arrow">→</span>
      </button>
      <a
        href="so-funktioniert"
        class="more-link"
        data-ga-content-link
        data-ga-section="how_it_works"
        >{{ trans.get('landing.how.more_link') }}</a
      >
    </div>
  </section>
</template>

<script>
import IconCheck from '../icons/IconCheck.vue';

export default {
  name: 'HowItWorksSection',
  components: { IconCheck },
  methods: {
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', {
        mode: 'register',
        cta_location: 'how_it_works',
      });
    },
  },
};
</script>
<style scoped lang="scss">
/* Base .how / .step / .vis-* / .chip styles are shared with SoFunktioniertPage
   and live in styles/landing.scss. This file only owns the compact variant
   overrides + the CTA row + the smaller chip offset for compact cards. */

.how--compact {
  gap: 22px;
}

.how--compact::before {
  top: 48px;
}

.how--compact .step {
  padding: 24px;
  border-radius: 24px;
}

.how--compact .step .num {
  font-size: 46px;
  margin-bottom: 12px;
}

.how--compact .step h3 {
  font-size: 21px;
}

.how--compact .step p {
  font-size: 14px;
  margin: 0 0 18px;
}

.how--compact .step .vis {
  height: 180px;
}

.how--compact .vis-profile .av {
  width: 64px;
  height: 64px;
}

.how--compact .step .chip.chip--verified {
  top: 12px;
  left: 12px;
}

.how-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
  margin-top: 42px;
  flex-wrap: wrap;
}
</style>
